// @ts-nocheck
import React, { useState, useEffect } from 'react';

const _t = () => (window).__ENGPORTAL_THEME || null;
const _dark = { bg: "#0B1120", surface: "#111827", surfaceHover: "#1a2332", border: "#1E293B", borderLight: "#334155", text: "#E2E8F0", textMuted: "#94A3B8", textDim: "#64748B", accent: "#3B82F6", accentGlow: "rgba(59, 130, 246, 0.15)", green: "#10B981", yellow: "#F59E0B", red: "#EF4444", purple: "#8B5CF6", orange: "#F97316", cardShadow: "none", mode: "dark" };
const theme = new Proxy(_dark, { get: (fallback, prop) => { const t = _t(); return t ? t[prop] : fallback[prop]; }});

const statusCfg = {
  requested:      { color: theme.purple, label: 'Requested' },
  approved:       { color: theme.accent, label: 'Approved' },
  submitted:      { color: theme.yellow, label: 'Submitted' },
  assigned:       { color: theme.accent, label: 'Assigned' },
  in_progress:    { color: theme.orange, label: 'In Progress' },
  pending_review: { color: theme.yellow, label: 'Review' },
  completed:      { color: theme.green, label: 'Completed' },
  rejected:       { color: theme.red, label: 'Rejected' },
  cancelled:      { color: theme.textDim, label: 'Cancelled' },
};

const TRANSITIONS = {
  requested:   [{ to: 'approved', label: 'Approve', color: theme.green }, { to: 'rejected', label: 'Reject', color: theme.red }, { to: 'cancelled', label: 'Cancel', color: theme.textDim }],
  approved:    [{ to: 'in_progress', label: 'Start Work', color: theme.accent }, { to: 'rejected', label: 'Reject', color: theme.red }, { to: 'cancelled', label: 'Cancel', color: theme.textDim }],
  in_progress: [{ to: 'submitted', label: 'Submit for Review', color: theme.yellow }, { to: 'cancelled', label: 'Cancel', color: theme.textDim }],
  submitted:   [{ to: 'completed', label: '✓ Complete', color: theme.green }, { to: 'rejected', label: 'Reject / Rework', color: theme.red }, { to: 'in_progress', label: 'Back to In Progress', color: theme.orange }],
  rejected:    [{ to: 'requested', label: 'Resubmit', color: theme.purple }, { to: 'cancelled', label: 'Cancel', color: theme.textDim }],
};


const csrfToken = () => document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';

export default function WorkOrdersPage({ openModal }) {
  const priorityColor = (p) => p === 'urgent' ? theme.red : p === 'high' ? theme.orange : p === 'normal' ? theme.yellow : theme.textDim;
  const [workOrders, setWorkOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('active');
  const [selectedWO, setSelectedWO] = useState(null);
  const [transitioning, setTransitioning] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [users, setUsers] = useState([]);

  const [currentUser, setCurrentUser] = React.useState(null);
  const loadData = async () => {
    try {
      const res = await fetch('/api/workorders/', { credentials: 'same-origin' });
      if (res.ok) { const data = await res.json(); setWorkOrders(Array.isArray(data) ? data : data.results || []); }
    } catch (e) {}
    try {
      const uRes = await fetch('/api/auth/users/', { credentials: 'same-origin' });
      if (uRes.ok) { const ud = await uRes.json(); setUsers(Array.isArray(ud) ? ud : ud.results || []); }
    } catch(e){}
    try {
      const meRes = await fetch('/api/auth/session-login/', { credentials: 'same-origin' });
      if (meRes.ok) { const me = await meRes.json(); setCurrentUser(me); }
    } catch(e){}
    setLoading(false);
  };
  useEffect(() => { loadData(); }, []);

  const handleAssign = async (woId, userId) => {
    try {
      const res = await fetch(`/api/workorders/${woId}/`, {
        method: 'PATCH', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken() },
        body: JSON.stringify({ assigned_to: userId || null }),
      });
      if (res.ok) {
        const updated = await res.json();
        setWorkOrders(prev => prev.map(w => w.id === woId ? updated : w));
        setSelectedWO(updated);
      }
    } catch(e){}
  };

  const handleTransition = async (woId, newStatus) => {
    setTransitioning(true);
    try {
      const res = await fetch(`/api/workorders/${woId}/transition/`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken() },
        body: JSON.stringify({ status: newStatus }),
      });
      if (res.ok) {
        const updated = await res.json();
        setWorkOrders(prev => prev.map(w => w.id === woId ? updated : w));
        setSelectedWO(updated);
      } else {
        const err = await res.json();
        alert(err.detail || 'Transition failed');
      }
    } catch (e) { alert('Network error'); }
    setTransitioning(false);
  };

  const handleDelete = async (woId) => {
    try {
      const res = await fetch(`/api/workorders/${woId}/delete/`, {
        method: 'DELETE', credentials: 'same-origin',
        headers: { 'X-CSRFToken': csrfToken() },
      });
      if (res.ok || res.status === 204) {
        setWorkOrders(prev => prev.filter(w => w.id !== woId));
        setSelectedWO(null); setConfirmDelete(null);
      } else {
        const err = await res.json().catch(() => ({}));
        alert(err.detail || 'Delete failed');
      }
    } catch (e) { alert('Network error'); }
  };

  const isManager = currentUser?.role === 'engineering_manager' || currentUser?.role === 'executive';
  const myWOs = isManager ? workOrders : workOrders.filter(w => w.status !== 'requested' && (w.assigned_to === currentUser?.id || w.requested_by === currentUser?.id));
  const filtered = filter === 'all' ? myWOs : filter === 'completed' ? myWOs.filter(w => w.status === 'completed') : myWOs.filter(w => !['completed','cancelled','rejected'].includes(w.status));
  const counts = {};
  workOrders.forEach(w => { counts[w.status] = (counts[w.status]||0) + 1; });

  // Detail panel
  if (selectedWO) {
    const wo = selectedWO;
    const sc = statusCfg[wo.status] || { color: theme.textDim, label: wo.status };
    const actions = TRANSITIONS[wo.status] || [];

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, height: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => setSelectedWO(null)} style={{ background: 'none', border: `1px solid ${theme.border}`, borderRadius: 6, padding: '6px 12px', color: theme.textMuted, cursor: 'pointer', fontSize: 12 }}>← Back</button>
          <span style={{ color: theme.accent, fontSize: 14, fontWeight: 600 }}>{wo.number || wo.work_order_number}</span>
          <span style={{ background: sc.color+'22', color: sc.color, fontSize: 11, padding: '3px 10px', borderRadius: 6, fontWeight: 600 }}>{sc.label}</span>
        </div>

        <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 24, flex: 1, overflow: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 20 }}>
            <div>
              <h3 style={{ color: theme.text, fontSize: 20, fontWeight: 700, margin: 0 }}>{wo.title}</h3>
              <div style={{ color: theme.textDim, fontSize: 12, marginTop: 6 }}>
                Type: <span style={{ color: theme.textMuted, textTransform: 'capitalize' }}>{(wo.work_type||'').replace(/_/g,' ')}</span>
                {' · '}Priority: <span style={{ color: priorityColor(wo.priority), fontWeight: 600 }}>{wo.priority}</span>
                {wo.requested_by_name && <>{' · '}Requested by: <span style={{ color: theme.textMuted }}>{wo.requested_by_name}</span></>}
                {wo.assigned_to_name && <>{' · '}Assigned: <span style={{ color: theme.textMuted }}>{wo.assigned_to_name}</span></>}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => setConfirmDelete(wo.id)}
                style={{ padding: '6px 12px', borderRadius: 6, fontSize: 11, background: theme.red+'15', color: theme.red, border: `1px solid ${theme.red}33`, cursor: 'pointer' }}>
                Delete
              </button>
            </div>
          </div>

          {wo.description && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ color: theme.textDim, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>Description / Details</div>
              <div style={{ color: theme.textMuted, fontSize: 13, lineHeight: 1.7, whiteSpace: 'pre-wrap', background: theme.bg, padding: 14, borderRadius: 8, border: `1px solid ${theme.border}` }}>{wo.description}</div>
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
            {[
              { l: 'Needed By', v: wo.needed_by || '—' },
              { l: 'Created', v: wo.created_at ? new Date(wo.created_at).toLocaleDateString() : '—' },
              { l: 'Program', v: wo.program_code || '—' },
            ].map(f => (
              <div key={f.l} style={{ background: theme.bg, borderRadius: 8, padding: '10px 14px', border: `1px solid ${theme.border}` }}>
                <div style={{ color: theme.textDim, fontSize: 10, textTransform: 'uppercase', marginBottom: 4 }}>{f.l}</div>
                <div style={{ color: theme.text, fontSize: 13 }}>{f.v}</div>
              </div>
            ))}
          </div>

          {/* Assignment */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ color: theme.textDim, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>Assign To</div>
            <select value={wo.assigned_to || ''} onChange={e => handleAssign(wo.id, e.target.value)}
              style={{ padding: '8px 12px', background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, fontSize: 13, outline: 'none', appearance: 'auto', minWidth: 200 }}>
              <option value="">— Unassigned —</option>
              {users.map(u => <option key={u.id} value={u.id}>{u.full_name || u.username} ({u.role?.replace(/_/g,' ')})</option>)}
            </select>
          </div>

          {/* Status Workflow */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ color: theme.textDim, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', marginBottom: 10 }}>Workflow Status</div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 14 }}>
              {['requested','approved','in_progress','submitted','completed'].map((s, i) => {
                const isCurrent = wo.status === s;
                const isPast = ['requested','approved','in_progress','submitted','completed'].indexOf(wo.status) > i;
                const c = statusCfg[s]?.color || theme.textDim;
                return (
                  <React.Fragment key={s}>
                    {i > 0 && <div style={{ flex: 1, height: 2, background: isPast ? c : theme.border }} />}
                    <div style={{ width: isCurrent ? 32 : 12, height: isCurrent ? 32 : 12, borderRadius: '50%', background: (isPast || isCurrent) ? c : theme.border, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s', border: isCurrent ? `3px solid ${c}44` : 'none' }}>
                      {(isPast || isCurrent) && <span style={{ color: '#fff', fontSize: isCurrent ? 12 : 6 }}>{isPast ? '✓' : '●'}</span>}
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
              {['Requested','Approved','In Progress','Submitted','Completed'].map(s => (
                <span key={s} style={{ color: theme.textDim, fontSize: 9, width: 60, textAlign: 'center' }}>{s}</span>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          {actions.length > 0 && (
            <div>
              <div style={{ color: theme.textDim, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', marginBottom: 10 }}>Actions</div>
              <div style={{ display: 'flex', gap: 8 }}>
                {actions.map(a => (
                  <button key={a.to} onClick={() => handleTransition(wo.id, a.to)} disabled={transitioning}
                    style={{ padding: '10px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600, background: a.color, color: '#fff', border: 'none', cursor: 'pointer', opacity: transitioning ? 0.6 : 1, transition: 'all 0.15s' }}>
                    {a.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {wo.status === 'completed' && (
            <div style={{ background: theme.green+'15', border: `1px solid ${theme.green}33`, borderRadius: 8, padding: '12px 16px', marginTop: 10 }}>
              <span style={{ color: theme.green, fontSize: 14, fontWeight: 600 }}>✓ Completed</span>
              {wo.completed_at && <span style={{ color: theme.textDim, fontSize: 12, marginLeft: 8 }}>{new Date(wo.completed_at).toLocaleDateString()}</span>}
            </div>
          )}
        </div>

        {/* Delete Confirmation */}
        {confirmDelete && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div style={{ background: theme.surface, border: `1px solid ${theme.red}44`, borderRadius: 12, padding: 24, maxWidth: 400 }}>
              <div style={{ color: theme.text, fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Delete Work Order?</div>
              <div style={{ color: theme.textMuted, fontSize: 13, marginBottom: 20 }}>This will permanently delete <strong>{wo.number || wo.work_order_number}</strong>: {wo.title}. This cannot be undone.</div>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button onClick={() => setConfirmDelete(null)} style={{ padding: '8px 16px', borderRadius: 6, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer', fontSize: 13 }}>Cancel</button>
                <button onClick={() => handleDelete(confirmDelete)} style={{ padding: '8px 16px', borderRadius: 6, background: theme.red, color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Delete</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, height: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ color: theme.text, fontSize: 20, fontWeight: 700, margin: 0 }}>Work Orders</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          {['active','all','completed'].map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{ padding: '6px 14px', borderRadius: 6, fontSize: 12, cursor: 'pointer', border: filter===f?`1px solid ${theme.accent}`:`1px solid ${theme.border}`, background: filter===f?theme.accentGlow:'transparent', color: filter===f?theme.accent:theme.textMuted, textTransform:'capitalize' }}>{f}</button>
          ))}
          <button onClick={() => openModal && openModal('workorder')} style={{ padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 600, background: theme.purple, color: '#fff', border: 'none', cursor: 'pointer' }}>+ New Work Order</button>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {Object.entries(statusCfg).filter(([k]) => counts[k]).map(([k, v]) => (
          <div key={k} style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 8, padding: '8px 14px', textAlign: 'center', cursor: 'pointer' }}
            onClick={() => setFilter('all')}>
            <div style={{ color: v.color, fontSize: 18, fontWeight: 700 }}>{counts[k]}</div>
            <div style={{ color: theme.textDim, fontSize: 9, textTransform: 'uppercase' }}>{v.label}</div>
          </div>
        ))}
      </div>
      {loading ? <div style={{ color: theme.textDim, padding: 40, textAlign: 'center' }}>Loading...</div> : (
        <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
          {filtered.length === 0 && <div style={{ color: theme.textDim, textAlign: 'center', padding: 40 }}>No work orders found</div>}
          {filtered.map(wo => {
            const sc = statusCfg[wo.status] || { color: theme.textDim, label: wo.status };
            return (
              <div key={wo.id} onClick={() => setSelectedWO(wo)}
                style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: theme.surface, border: `1px solid ${theme.border}`, borderLeft: `4px solid ${sc.color}`, borderRadius: 10, cursor: 'pointer', transition: 'all 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = sc.color}
                onMouseLeave={e => e.currentTarget.style.borderColor = theme.border}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <span style={{ color: theme.accent, fontSize: 11, fontWeight: 600 }}>{wo.number || wo.work_order_number}</span>
                    <div style={{ width: 4, height: 14, borderRadius: 2, background: priorityColor(wo.priority) }} />
                    <span style={{ color: theme.textDim, fontSize: 10, textTransform: 'capitalize' }}>{(wo.work_type||'').replace(/_/g,' ')}</span>
                  </div>
                  <div style={{ color: theme.text, fontSize: 14, fontWeight: 500 }}>{wo.title}</div>
                  <div style={{ color: theme.textDim, fontSize: 11, marginTop: 4 }}>
                    {wo.requested_by_name ? `By: ${wo.requested_by_name}` : ''}{wo.assigned_to_name ? ` · Assigned: ${wo.assigned_to_name}` : ''}{wo.program_code ? ` · ${wo.program_code}` : ''}
                  </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                  <span style={{ background: sc.color+'22', color: sc.color, fontSize: 10, padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>{sc.label}</span>
                  {wo.needed_by && <div style={{ color: theme.textDim, fontSize: 10, marginTop: 4 }}>Due: {wo.needed_by}</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
